import { AnchorButton } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import * as Sentry from '@sentry/browser'
import * as React from 'react'
import PrinterToaster from '../printing/toaster'
import PrinterV2 from '../printing/printer'
import { blurActiveInput } from '../routes/orders/packing/utils'

interface Props {
  inventoryUnitId: number
}

const PrintMediaTicketButton: React.FC<Props> = ({ inventoryUnitId }) => {
  const [loading, setLoading] = React.useState(false)

  const handleClick = async (event: React.MouseEvent<HTMLElement>) => {
    setLoading(true)

    const newTabPdfPrinter = event.ctrlKey || event.metaKey
    const printer = new PrinterV2(newTabPdfPrinter)

    try {
      const success = await printer.printMediaTicketFromId(inventoryUnitId)
      if (!success) {
        PrinterToaster.show({
          intent: 'danger',
          message: 'Unable to print media ticket'
        })
      }
    } catch (error) {
      Sentry.captureException(error)
      PrinterToaster.show({
        intent: 'danger',
        message: 'An unexpected error occurred while printing the media ticket'
      })
    } finally {
      setLoading(false)
      blurActiveInput()
    }
  }

  return <AnchorButton loading={loading} intent="primary" onClick={handleClick} icon={IconNames.PRINT} small minimal />
}

export default PrintMediaTicketButton
